// src/pages/DashboardNavigation/data/dashboardNavigationData.js

export const DISPLAY_BY_PATH_RAW = {
  // Utilisateur
  "/absences": "display_absences",
  "/calendrier": "display_calendrier",
  "/chat": "display_chat",
  "/boutique": "display_boutique",
  "/commandes-&-reglements": "display_commandes",
  "/prepa-physique": "display_prepa_physique",
  "/actualites": "display_news",
  "/galerie-photos": "display_galerie",
  "/lexique": "display_lexique",
  "/arbitrage-judo": "display_arbitrage",
  "/applications-judo": "display_applications",
  "/documents-passage-ceinture": "display_passage_ceinture_documents",
  "/techniques-judo": "display_techniques",
  "/techniques-quizz": "display_techniquesquizz",
  "/vote-sondage-utilisateur": "display_vote",

  // Enseignant
  "/appel-presence": "display_appels",
  "/tableau-appel": "display_tableauappel",
  "/passage-ceinture": "display_passage",
  "/grade-cn": "display_gradecn",
  "/evenements": "display_evenements",
  "/prepa-physique-coaching": "display_prepa_physique_coaching",
  "/suivi-competitions": "display_suivicompetition",
  "/palmares": "display_palmares",
  "/objectifs": "display_objectifs",
  "/todolist": "display_todolist",
  "/techniques-enseignants": "display_techniquesenseignants",
  "/categories": "display_categories",
  "/fiche-de-frais": "display_fichefrais",

  // Admin
  "/articles-admin": "display_articlesadmin",
  "/depenses-recettes": "display_depensesrecettes",
  "/coachings": "display_coaching",
  "/heures-enseignement": "display_heures_enseignants",
  "/fiche-de-frais-admin": "display_fichefraisadmin",
  "/inventaire": "display_inventaire",
  "/pret-materiel": "display_pretmateriel",
  "/chat-page-admin": "display_chat_admin",
  "/message-admin": "display_messages_admin",
  "/vote-sondage-admin": "display_voteadmin",
  "/pages-personnalisees": "display_pagespersonnalisees",
};

export const PATH_LABELS = {
  "/tableau-de-bord": "Tableau de bord",
  "/dossier-d-inscription": "Dossier d'inscription",
  "/fiche-adherent": "Ma fiche adhérent",
  "/absences": "Absences",
  "/calendrier": "Calendrier",
  "/messages": "Messages",
  "/chat": "Chat",
  "/boutique": "Boutique",
  "/commandes-&-reglements": "Commandes & règlements",
  "/actualites": "Actualités",
  "/galerie-photos": "Galerie photos",
  "/lexique": "Lexique",
  "/arbitrage-judo": "Arbitrage Judo",
  "/arbitrage-jjb": "Arbitrage JJB",
  "/applications-judo": "Applications Judo",
  "/prepa-physique": "Prépa physique",
  "/documents-passage-ceinture": "Documents ceinture",
  "/techniques-judo": "Techniques Judo",
  "/techniques-quizz": "Quiz techniques",
  "/vote-sondage-utilisateur": "Votes & sondages",

  "/listing-adherents": "Listing adhérents",
  "/appel-presence": "Appel présence",
  "/tableau-appel": "Tableau d'appel",
  "/passage-ceinture": "Passage ceinture",
  "/grade-cn": "Grades CN",
  "/prepa-physique-coaching": "Coaching physique",
  "/suivi-competitions": "Suivi compétitions",
  "/evenements": "Évènements",
  "/palmares": "Palmarès",
  "/objectifs": "Objectifs",
  "/todolist": "Todo list",
  "/techniques-enseignants": "Techniques enseignants",
  "/categories": "Catégories",
  "/aide-enseignants": "Aide enseignants",

  "/dashboard-adherents": "Dashboard adhérents",
  "/dashboard-comptabilite": "Comptabilité",
  "/details-adherent": "Détails adhérent",
  "/listing-utilisateurs": "Utilisateurs",
  "/listing-adherents-admin": "Adhérents admin",
  "/reglements-inscriptions": "Règlements inscriptions",
  "/dossiers-d-inscription": "Dossiers inscription",
  "/paiements": "Paiements",
  "/articles-admin": "Articles",
  "/depenses-recettes": "Dépenses / recettes",
  "/coachings": "Coachings",
  "/heures-enseignement": "Heures enseignement",
  "/inventaire": "Inventaire",
  "/pret-materiel": "Prêt matériel",
  "/chat-page-admin": "Chat admin",
  "/message-admin": "Messages admin",
  "/vote-sondage-admin": "Votes admin",
  "/pages-personnalisees": "Pages personnalisées",
  "/parametres": "Paramètres",
  "/requetes-admin": "Requêtes",
  "/abonnement": "Abonnement",
  "/update": "Mises à jour",
  "/aide-conseils": "Aide & conseils",
};

export const NAVIGATION_SECTIONS = {
  user: {
    id: "user",
    label: "Utilisateur",
    shortLabel: "User",
    description: "Pages accessibles à l’adhérent ou au parent.",
    items: [
      "/tableau-de-bord",
      "/dossier-d-inscription",
      "/fiche-adherent",
      "/absences",
      "/calendrier",
      "/messages",
      "/chat",
      "/boutique",
      "/commandes-&-reglements",
      "/actualites",
      "/galerie-photos",
      "/lexique",
      "/arbitrage-judo",
      "/arbitrage-jjb",
      "/applications-judo",
      "/prepa-physique",
      "/documents-passage-ceinture",
      "/techniques-judo",
      "/techniques-quizz",
      "/vote-sondage-utilisateur",
    ],
  },

  enseignant: {
    id: "enseignant",
    label: "Enseignant",
    shortLabel: "Coach",
    description: "Pages de suivi sportif, présences, grades et compétitions.",
    items: [
      "/listing-adherents",
      "/appel-presence",
      "/tableau-appel",
      "/passage-ceinture",
      "/grade-cn",
      "/prepa-physique-coaching",
      "/suivi-competitions",
      "/evenements",
      "/palmares",
      "/objectifs",
      "/todolist",
      "/techniques-enseignants",
      "/categories",
      "/fiche-de-frais",
      "/aide-enseignants",
    ],
  },

  admin: {
    id: "admin",
    label: "Administrateur",
    shortLabel: "Admin",
    description: "Pages de gestion du club, des adhérents et des paramètres.",
    items: [
      "/dashboard-adherents",
      "/dashboard-comptabilite",
      "/details-adherent",
      "/listing-utilisateurs",
      "/listing-adherents-admin",
      "/reglements-inscriptions",
      "/dossiers-d-inscription",
      "/paiements",
      "/articles-admin",
      "/depenses-recettes",
      "/coachings",
      "/fiche-de-frais-admin",
      "/heures-enseignement",
      "/inventaire",
      "/pret-materiel",
      "/chat-page-admin",
      "/message-admin",
      "/vote-sondage-admin",
      "/pages-personnalisees",
      "/parametres",
      "/requetes-admin",
      "/abonnement",
      "/update",
      "/aide-conseils",
    ],
  },
};

export const SECTION_IDS_BY_ROLE = {
  user: ["user"],
  enseignant: ["user", "enseignant"],
  admin: ["user", "enseignant", "admin"],
};
